/* global window, document */

import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux';
import { browserHistory } from 'react-router';

import Store from './config/Store';
import Routes from './config/Routes';

import './index.css';
import registerServiceWorker from './registerServiceWorker';

ReactGA.initialize('UA-59966874-8');

const logPageView = (page) => {
  ReactGA.set({ page });
  ReactGA.pageview(page);
};

logPageView(window.location.pathname + window.location.search);

const history = syncHistoryWithStore(browserHistory, Store);
history.listen(location => logPageView(location.pathname + location.search));

ReactDOM.render(
  <Provider store={Store}>
    <Routes history={history} />
  </Provider>,
  document.getElementById('root'),
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js